module.exports = __webpack_public_path__ + "img/desktop.af2d2cea.jpg";